module.exports = {
          srcSet: __webpack_public_path__ + "b32e83aa8a5d94e2d5daf3736b2d2156-2336.png"+" 2336w",
          images:[ {path: __webpack_public_path__ + "b32e83aa8a5d94e2d5daf3736b2d2156-2336.png",width: 2336,height: 396}],
          src: __webpack_public_path__ + "b32e83aa8a5d94e2d5daf3736b2d2156-2336.png",
          toString:function(){return __webpack_public_path__ + "b32e83aa8a5d94e2d5daf3736b2d2156-2336.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAACCAYAAABhYU3QAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAXUlEQVR4nAFSAK3/ACMiJ/w3Nzv/ODg9/kJCR/8zNjz/LiUp/7xoSP9mPCj+SkE1/089MvkAGhke/CkoLf8mJiv+Li4z/ygrNP85MSj/uWY6/29CM/6xjUv/rIg0+VAII1UN67TvAAAAAElFTkSuQmCC",
          width: 2336,
          height: 396
        }